import React, {useContext} from 'react';
import {FaSun, FaMoon} from 'react-icons/fa';
import {ThemeContext} from "../../../ThemeContext";

export default () => {
  const {theme, toggleTheme} = useContext(ThemeContext);
  const label = theme === 'light' ? "Przełącz na ciemny motyw" : "Przełącz na jasny motyw";
  return <div onClick={toggleTheme} 
              style={{cursor:'pointer',borderRadius:'30%',padding:'5px'}}
              role="button" tabIndex={0} aria-label={label} title={label}>
    {theme === 'light' ? <FaSun style={{color:'#ff9800'}}/> : <FaMoon style={{color:'white'}}/>}
  </div>;
};
